import { render, staticRenderFns } from "./OwnersFivesVacationsEdit.vue?vue&type=template&id=81386df6&scoped=true&"
import script from "./OwnersFivesVacationsEdit.vue?vue&type=script&lang=js&"
export * from "./OwnersFivesVacationsEdit.vue?vue&type=script&lang=js&"
import style0 from "./OwnersFivesVacationsEdit.vue?vue&type=style&index=0&id=81386df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81386df6",
  null
  
)

export default component.exports